import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { statusHex, isMarked, labelFor } from "../attendanceHelpers";
import ClientLevelPills from "./ClientLevelPills";

function BookingClientList({ clients, sx }) {
  return (
    <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1.5, overflow: "hidden", ...sx }}>
      {clients.map((c, i) => {
        const marked = isMarked(c.status);
        const hex = statusHex(c.status);
        return (
          <Box
            key={c.bookishClientId || c._id}
            sx={{
              px: 1.25,
              py: 1,
              borderTop: i > 0 ? "1px solid" : "none",
              borderColor: "divider"
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body2" noWrap sx={{ fontWeight: 600, flex: 1, minWidth: 0 }}>
                  {c.name || "Client"}
                </Typography>
                {marked && (
                  <Box
                    component="span"
                    sx={{
                      flexShrink: 0,
                      px: 0.75,
                      borderRadius: "9999px",
                      fontSize: "0.6875rem",
                      fontWeight: 700,
                      lineHeight: 1.6,
                      color: hex,
                      bgcolor: alpha(hex, 0.14)
                    }}
                  >
                    {labelFor(c.status)}
                  </Box>
                )}
              </Box>
              <ClientLevelPills levels={c.levels} sx={{ mt: 0.5 }} />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default BookingClientList;
